<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="getDataReport($event)"
>
</mt-filter>
<div
    class="report-container mt-4"
    *ngIf="tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ "report-operational-discipline" | lang | uppercase }}
                </div>
            </div>
            <div class="float-right" *ngIf="tableConfig">
                <app-button-icon
                    [image]="'download'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcelFile()"
                ></app-button-icon>
            </div>
        </div>
    </div>
    <div [ngClass]="{ 'body-container': tableConfig }">
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="error"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>
        <app-main-table
            *ngIf="tableConfig"
            [tableConfig]="tableConfig"
            (sendInfoToComponent)="viewDetailRow($event)"
        ></app-main-table>
    </div>
</div>
